module.exports = __webpack_public_path__ + "static/media/radio-active.eab29606.svg";